import { EDITOR_MODE, useEditorMode } from "@pathwright/blocks-engine"
import PropTypes from "prop-types"
import { memo, useMemo } from "react"
import BlockLoading from "./BlockLoading"
import BlockWrap, { EditorBlockWrap } from "./BlockWrap"
import { getBlock } from "./utils"

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.block !== prevProps.block) return false
  if (nextProps.blockIndex !== prevProps.blockIndex) return false

  return true
}

const BlockContainer = memo((props) => {
  const { blockIndex, block, onChange } = props
  const { type, style } = block
  const { mode } = useEditorMode()

  const blockStyles = useMemo(() => block.style, [block.style])

  const Block = useMemo(() => getBlock(type, mode), [type, mode])

  if (!Block) return <BlockLoading />

  const WrapComponent = mode === EDITOR_MODE.EDIT ? EditorBlockWrap : BlockWrap

  return (
    <WrapComponent
      styledColor={style?.styleAttributes.color}
      style={{
        ...(style?.styleAttributes || {}),
        transition: "all 0.5s"
      }}
      index={blockIndex}
    >
      <Block
        {...block}
        onChange={onChange}
        blockIndex={blockIndex}
        blockStyles={blockStyles}
      />
    </WrapComponent>
  )
}, propsAreEqual)

BlockContainer.propTypes = {
  onChange: PropTypes.func.isRequired,
  block: PropTypes.object.isRequired,
  blockIndex: PropTypes.number
}

export default BlockContainer
